import { ITileset } from '~/client/graph'

import { MapboxSourceType } from '../components/MapBoxViewer/mapboxConstants'

/** A self-hosted tileset stores its TileJSON url where a Mapbox-hosted one stores a Mapbox id. */
export function isSelfHostedTilesetId(mapboxTilesetId: string): boolean {
  return !!mapboxTilesetId?.startsWith('https://')
}

/**
 * Gives a self-hosted tileset the `mapboxData` every list and renderer requires, since only the
 * Mapbox account listing fills it and a self-hosted tileset is never in that listing. The type is
 * assumed vector; the centre and size Mapbox would report do not exist for it.
 */
export function withSelfHostedMapboxData(tileset: ITileset): ITileset {
  if (tileset?.mapboxData || !isSelfHostedTilesetId(tileset?.mapboxTilesetId)) {
    return tileset
  }
  return {
    ...tileset,
    mapboxData: {
      id: tileset.mapboxTilesetId,
      name: tileset.name,
      type: MapboxSourceType.Vector,
      center: [],
      fileSize: 0,
    },
  }
}
